import axios from "axios";
import config from "../config/config";
import { getCookie } from "config/cookies";
import { parse, stringify } from "qs";

const axiosClient = axios.create({
  // baseURL: "https://api.thuthu.ml",
  baseURL: config.base_url,
  headers: {
    "Content-Type": "application/json",
  },
  paramsSerializer: {
    encode: parse,
    serialize: stringify,
  },
});

axiosClient.interceptors.request.use(
  async (config) => {
    if (getCookie("user") === "undefined") {
      return config;
    } else {
      const user = getCookie("user") ? JSON.parse(getCookie("user")) : null;
      const token = user ? user.token : null;
      if (token) {
        config.headers.Authorization = `Token ${token}`;
      }
      return config;
    }
  },
  (error) => {
    throw error;
  }
);

axiosClient.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      return response.data;
    }
    return response;
  },
  (error) => {
    throw error;
  }
);

export default axiosClient;
